import { constants, price as priceUtils } from '@eti/utils';
export const getPrice = ({
  sellSpecification
}, type = 'none', pricePerTraveler) => {
  var _sellSpecification$se3;
  if (type === 'none') {
    var _sellSpecification$pr, _sellSpecification$pr2;
    return (_sellSpecification$pr = sellSpecification === null || sellSpecification === void 0 || (_sellSpecification$pr2 = sellSpecification.price) === null || _sellSpecification$pr2 === void 0 || (_sellSpecification$pr2 = _sellSpecification$pr2.price) === null || _sellSpecification$pr2 === void 0 ? void 0 : _sellSpecification$pr2.value) !== null && _sellSpecification$pr !== void 0 ? _sellSpecification$pr : 0;
  }
  if (pricePerTraveler) {
    var _sellSpecification$se, _sellSpecification$se2;
    return (_sellSpecification$se = sellSpecification === null || sellSpecification === void 0 || (_sellSpecification$se2 = sellSpecification.sellPriceTravelers) === null || _sellSpecification$se2 === void 0 || (_sellSpecification$se2 = _sellSpecification$se2[0]) === null || _sellSpecification$se2 === void 0 || (_sellSpecification$se2 = _sellSpecification$se2.price) === null || _sellSpecification$se2 === void 0 || (_sellSpecification$se2 = _sellSpecification$se2.price) === null || _sellSpecification$se2 === void 0 ? void 0 : _sellSpecification$se2.value) !== null && _sellSpecification$se !== void 0 ? _sellSpecification$se : 0;
  }
  return sellSpecification === null || sellSpecification === void 0 || (_sellSpecification$se3 = sellSpecification.sellPriceTravelers) === null || _sellSpecification$se3 === void 0 ? void 0 : _sellSpecification$se3.reduce((total, traveler) => total + traveler.price.price.value, 0);
};
export const getProduct = (id, order, type = 'none') => {
  var _order$bounds$length, _order$bounds, _order$travelers, _product$sellSpecific, _product$configuratio, _product$configuratio2, _product$texts, _product$texts2;
  const numberOfBounds = (_order$bounds$length = order === null || order === void 0 || (_order$bounds = order.bounds) === null || _order$bounds === void 0 ? void 0 : _order$bounds.length) !== null && _order$bounds$length !== void 0 ? _order$bounds$length : 0;
  const numberOfTravelers = order === null || order === void 0 || (_order$travelers = order.travelers) === null || _order$travelers === void 0 ? void 0 : _order$travelers.filter(traveler => traveler.ageType !== constants.ageTypes.INFANT).length;
  const product = order !== null && order !== void 0 && order.availableExtraProducts ? order.availableExtraProducts.find(extraProduct => String(extraProduct.id) === String(id)) : order;
  if (!product) {
    return null;
  }
  const travelerIds = (_product$sellSpecific = product.sellSpecification) === null || _product$sellSpecific === void 0 || (_product$sellSpecific = _product$sellSpecific.sellPriceTravelers) === null || _product$sellSpecific === void 0 ? void 0 : _product$sellSpecific.map(({
    travelerId
  }) => travelerId);
  const priceRaw = getPrice(product, type);
  const {
    highlightProduct,
    showPricePerBound,
    showPricePerTraveler
  } = ((_product$configuratio = product.configuration) === null || _product$configuratio === void 0 ? void 0 : _product$configuratio.travelerDetails) || ((_product$configuratio2 = product.configuration) === null || _product$configuratio2 === void 0 ? void 0 : _product$configuratio2.postbookingAncillaryStore) || {};
  const phonePrefixMarketTexts = {
    name: product.name,
    abstractText: product === null || product === void 0 || (_product$texts = product.texts) === null || _product$texts === void 0 ? void 0 : _product$texts.salesAbstract,
    smallCardAbstract: product === null || product === void 0 || (_product$texts2 = product.texts) === null || _product$texts2 === void 0 ? void 0 : _product$texts2.smallCardText
  };
  return {
    numberOfBounds,
    numberOfTravelers,
    phonePrefixMarketTexts,
    priceRaw,
    isProductHighlighted: highlightProduct,
    shouldShowPricePerBound: showPricePerBound,
    shouldShowPricePerTraveler: showPricePerTraveler,
    ...(showPricePerTraveler ? {
      pricePerTravelerRaw: type === 'traveler' ? getPrice(product, type, true) : priceUtils.getPriceDivided(priceRaw, numberOfTravelers)
    } : {}),
    readMore: {
      isEnabled: true
    },
    travelerIds
  };
};
export const getSelection = (name, id, form, travelers, {
  sellPriceTravelers
} = {}) => {
  var _form$name, _sellPriceTravelers$m;
  return ((_form$name = form[name]) === null || _form$name === void 0 ? void 0 : _form$name.value.value) === true ? {
    productId: id,
    ...(sellPriceTravelers ? {
      selectionTraveler: (_sellPriceTravelers$m = sellPriceTravelers === null || sellPriceTravelers === void 0 ? void 0 : sellPriceTravelers.map(({
        travelerId
      }) => Number(travelerId))) !== null && _sellPriceTravelers$m !== void 0 ? _sellPriceTravelers$m : {}
    } : {
      selectionNone: true
    })
  } : undefined;
};
//# sourceMappingURL=singleChoiceTransformer.js.map